var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198px",
    height: "198px",
    viewBox: "0 0 198.0 198.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,1476 L0,1476 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5,0 C84.5995189,0 109,24.4004811 109,54.5 C109,84.5995189 84.5995189,109 54.5,109 C24.4004811,109 0,84.5995189 0,54.5 C0,24.4004811 24.4004811,0 54.5,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94,0 L94,63 L0,63 L0,0 L94,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.030646,0 L110.030646,73.503937 L0,73.503937 L0,0 L110.030646,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,0 L125,83.503937 L0,83.503937 L0,0 L125,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.9423077,0 L88.9423077,48.511811 L0,48.511811 L0,0 L88.9423077,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8621795,0 L25.2970085,1.18549081 C28.5181624,2.29781627 30.982906,6.10665617 30.982906,9.49240945 L30.982906,18.4185827 L0,18.4185827 L0,9.49240945 C0,6.10665617 2.1207265,2.29781627 5.34188034,1.18549081 L8.77777778,0 C10.5470085,1.91608399 12.8418803,3.04325459 15.3194444,3.04325459 C17.7980769,3.04325459 20.0918803,1.91608399 21.8621795,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00652896,0 C13.8003324,0 18.2212726,3.72507087 18.2212726,8.48293963 C18.2212726,9.1191601 18.1283238,9.72993176 17.9969136,10.3269186 C18.1379392,10.7478845 18.2212726,11.2526194 18.2212726,11.7965879 C18.2212726,13.2609554 17.7511871,14.4464462 17.0140076,14.4464462 C16.8751187,14.4464462 16.7447768,14.3923675 16.6187085,14.3149606 C15.6379392,18.2425617 12.2394349,21.2073491 9.00652896,21.2073491 C5.77362298,21.2073491 3.03751187,18.376168 2.05674264,14.4485669 C1.93067426,14.5259738 1.80033238,14.5800525 1.66144349,14.5800525 C0.924264008,14.5800525 0.325973409,13.3935013 0.325973409,11.9291339 C0.325973409,11.3851654 -0.0832146249,11.0246404 0.0588793922,10.6036745 C-0.0735992403,10.0066877 0.0588793922,9.1191601 0.0588793922,8.48293963 C0.0588793922,3.72507087 4.21272555,0 9.00652896,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7897116,0 L27.5194742,1.86357155 C31.0183025,3.07178327 33.6537384,6.63307081 33.6537384,10.3106876 L33.6537384,19.3207727 L0,19.3207727 L0,10.3106876 C0,6.63307081 2.34531742,3.07178327 5.84414574,1.86357155 L9.57738976,0 C11.4991343,2.08125698 13.9918319,3.30559354 16.6829705,3.30559354 C19.3752695,3.30559354 21.8679671,2.08125698 23.7897116,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4442636,0 C15.6513093,0 19.7280535,4.04618471 19.7280535,9.21419803 C19.7280535,9.90526288 19.6270923,10.8692983 19.4843541,11.5177475 C19.6375366,11.9750021 19.7280535,12.5232469 19.7280535,13.1141073 C19.7280535,14.7047083 19.0781882,15.9935442 18.2774614,15.9935442 C18.1265998,15.9935442 18.1242788,16.2089261 17.9873429,16.1248465 C16.922028,20.3910202 13.2305611,23.0354951 9.71896755,23.0354951 C6.20737402,23.0354951 2.8060255,19.8151329 1.74071061,15.5489592 C1.60377471,15.6330387 1.60145376,15.692931 1.45059217,15.692931 C0.649865293,15.692931 0,14.4040951 0,12.8134941 C0,12.2226337 0.0905169515,11.6743889 0.243699485,11.2171343 C0.100961215,10.5686851 0,9.90526288 0,9.21419803 C0,4.04618471 3.72279975,0 10.4442636,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1639957,0 L22.4022436,1.73502625 C25.2207532,2.70831102 27.1100427,5.34517979 27.1100427,8.30771391 L27.1100427,17.11221 L0,17.1103543 L0,8.07390289 C0,5.11229659 1.88928953,2.4745 4.70779915,1.50121522 L7.71514423,0 C9.26322115,1.67657349 11.271234,2.66284777 13.4391026,2.66284777 C15.607906,2.66284777 17.6159188,1.67657349 19.1639957,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.957265,0 L14.957265,1.39173228 C14.957265,1.59306955 14.9778312,2.12378346 14.957265,2.31955381 L14.957,2.318 C15.602297,2.31955381 15.892094,3.35778609 15.892094,4.63910761 C15.892094,5.92042913 15.3685897,6.95866142 14.7235577,6.95866142 C14.6029647,6.95866142 14.4898504,6.91227034 14.3804754,6.84546719 C13.5213675,10.2811903 10.6579861,12.5255906 7.82919338,12.5255906 C5.00040064,12.5255906 2.3707265,9.81727953 1.51161859,6.38155643 C1.40224359,6.44835958 1.28912927,6.49475066 1.16853632,6.49475066 C0.523504274,6.49475066 0,5.45651837 0,4.17519685 C0,2.89387533 0.289797009,1.84543701 0.93482906,1.84543701 C0.951655983,1.84543701 0.93482906,1.59306955 0.93482906,1.39173228 L14.957265,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0224359,0 L14.0224359,4.17519685 C14.0224359,4.17519685 11.5759882,5.56692913 7.01121795,5.56692913 C2.44644765,5.56692913 0,4.17519685 0,4.17519685 L14.0224359,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3482906,0 L19.6314103,0.927821522 L10.2831197,3.71128609 L0,2.78346457 L9.3482906,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 C62.09139,0 80,3.581722 80,8 C80,12.418278 62.09139,16 40,16 C17.90861,16 0,12.418278 0,8 C0,3.581722 17.90861,0 40,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.0 -579.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 480.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.0 99.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.0 44.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 109,0 109,109 0,109 0,0",
    stroke: "none",
    fill: "#FFF3DB"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.0 68.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 94,0 94,63 0,63 0,0",
    stroke: "none",
    fill: "#E5A419"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,63 94,63 94,0 0,0 0,63 0,63",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L13,13",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.0 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13 L13,0",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 50.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0 L0,13",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.0 50.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L13,13",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 68.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 94,0 94,63 0,63 0,0",
    stroke: "none",
    fill: "#E5A419"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,63 94,63 94,0 0,0 0,63 0,63",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L13,13",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.0 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13 L13,0",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 50.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0 L0,13",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.0 50.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L13,13",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.00000000000009 61.99999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 110.030646,0 110.030646,73.503937 0,73.503937 0,0",
    stroke: "none",
    fill: "#F6C355"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,73.503937 110.030646,73.503937 110.030646,0 0,0 0,73.503937 0,73.503937",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L15.5171424,15.4008249",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.51350353803238 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.4008249 L15.5171424,0",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 58.10311210476173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5171424,0 L0,15.4008249",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.51350353803238 58.10311210476173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L15.5171424,15.4008249",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000000000078 61.99999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 110.030646,0 110.030646,73.503937 0,73.503937 0,0",
    stroke: "none",
    fill: "#F6C355"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,73.503937 110.030646,73.503937 110.030646,0 0,0 0,73.503937 0,73.503937",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L15.5171424,15.4008249",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.51350353803238 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.4008249 L15.5171424,0",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 58.10311210476173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5171424,0 L0,15.4008249",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.51350353803238 58.10311210476173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L15.5171424,15.4008249",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.0 56.4960629921261)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 125,0 125,83.503937 0,83.503937 0,0",
    stroke: "none",
    fill: "#FFD67E"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,83.503937 125,83.503937 125,0 0,0 0,83.503937 0,83.503937",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L17.6282051,17.496063",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.3717948717949 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.496063 L17.6282051,0",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 66.0078740157478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6282051,0 L0,17.496063",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.3717948717949 66.0078740157478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L17.6282051,17.496063",
    stroke: "#16243C",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.62820512820508 17.496062992126102)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,48.511811 88.9423077,48.511811 88.9423077,0 0,0 0,48.511811 0,48.511811",
    stroke: "#16243C",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 88.9423077,0 88.9423077,48.511811 0,48.511811 0,0",
    stroke: "none",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.62820512820508 -17.496062992126102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.84807692307731 31.01574803149606)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 20.81533123359583)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 30.982906,0 30.982906,14.1767948 0,14.1767948 0,0",
    stroke: "none",
    fill: "#25D086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.8621795,0 C20.0918803,1.91608399 17.7980769,3.04325459 15.3194444,3.04325459 C12.8418803,3.04325459 10.5470085,1.91608399 8.77777778,0 L5.34188034,1.18549081 C2.1207265,2.29781627 0,6.10665617 0,9.49240945 L0,18.4185827 L30.982906,18.4185827 L30.982906,9.49240945 C30.982906,6.10665617 28.5181624,2.29781627 25.2970085,1.18549081 L21.8621795,0 Z",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.273717948717604 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0778727445394907 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.08721929e-14,0 18.2212726,0 18.2212726,21.2073491 -2.08721929e-14,21.2073491 -2.08721929e-14,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2212726,8.48293963 C18.2212726,3.72507087 13.8003324,0 9.00652896,0 C4.21272555,0 0.0588793922,3.72507087 0.0588793922,8.48293963 C0.0588793922,9.1191601 -0.0735992403,10.0066877 0.0588793922,10.6036745 C-0.0832146249,11.0246404 0.325973409,11.3851654 0.325973409,11.9291339 C0.325973409,13.3935013 0.924264008,14.5800525 1.66144349,14.5800525 C1.80033238,14.5800525 1.93067426,14.5259738 2.05674264,14.4485669 C3.03751187,18.376168 5.77362298,21.2073491 9.00652896,21.2073491 C12.2394349,21.2073491 15.6379392,18.2425617 16.6187085,14.3149606 C16.7447768,14.3923675 16.8751187,14.4464462 17.0140076,14.4464462 C17.7511871,14.4464462 18.2212726,13.2609554 18.2212726,11.7965879 C18.2212726,11.2526194 18.1379392,10.7478845 17.9969136,10.3269186 C18.1283238,9.72993176 18.2212726,9.1191601 18.2212726,8.48293963 L18.2212726,8.48293963 Z",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.1367521367519657 4.241469816272968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.36220472 C0,6.36220472 5.34188034,4.47369029 5.34188034,0 C5.34188034,1.20139633 12.3194444,6.36220472 18.1623932,6.36220472",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.478632478632789 11.66404199475068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1.06837607,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.88888888888869 11.66404199475068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1.06837607,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 8.482939632545936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13675214,0 C2.13675214,2.19496063 1.46047009,7.03341732 0,8.48293963 C1.35683761,9.8296063 6.41025641,10.7362205 6.41025641,10.7362205",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.75854700854688 8.482939632545936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.54059829,0 C4.54059829,2.19496063 5.21688034,7.03341732 6.67735043,8.48293963 C5.32051282,9.8296063 0,10.7362205 0,10.7362205",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.07051282051361 29.027559055118218)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 22.43143436341046)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 33.6537384,0 33.6537384,14.5488806 0,14.5488806 0,0",
    stroke: "none",
    fill: "#25D086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.7897116,0 C21.8679671,2.08125698 19.3752695,3.30559354 16.6829705,3.30559354 C13.9918319,3.30559354 11.4991343,2.08125698 9.57738976,0 L5.84414574,1.86357155 C2.34531742,3.07178327 0,6.63307081 0,10.3106876 L0,19.3207727 L33.6537384,19.3207727 L33.6537384,10.3106876 C33.6537384,6.63307081 31.0183025,3.07178327 27.5194742,1.86357155 L23.7897116,0 Z",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.962958474203333 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.7280535,0 19.7280535,23.0354951 0,23.0354951 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.7280535,9.21419803 C19.7280535,4.04618471 15.6513093,0 10.4442636,0 C3.72279975,0 0,4.04618471 0,9.21419803 C0,9.90526288 0.100961215,10.5686851 0.243699485,11.2171343 C0.0905169515,11.6743889 0,12.2226337 0,12.8134941 C0,14.4040951 0.649865293,15.692931 1.45059217,15.692931 C1.60145376,15.692931 1.60377471,15.6330387 1.74071061,15.5489592 C2.8060255,19.8151329 6.20737402,23.0354951 9.71896755,23.0354951 C13.2305611,23.0354951 16.922028,20.3910202 17.9873429,16.1248465 C18.1242788,16.2089261 18.1265998,15.9935442 18.2774614,15.9935442 C19.0781882,15.9935442 19.7280535,14.7047083 19.7280535,13.1141073 C19.7280535,12.5232469 19.6375366,11.9750021 19.4843541,11.5177475 C19.6270923,10.8692983 19.7280535,9.90526288 19.7280535,9.21419803 L19.7280535,9.21419803 Z",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5802368689024267 4.60709901426216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.91064852 L1.74071061,6.91064852 C1.74071061,6.91064852 1.85907893,2.30354951 2.90118434,2.30354951 C3.94328976,2.30354951 7.5430793,3.01419453 7.5430793,0 C7.5430793,1.3049608 11.224102,3.45532426 15.6663955,3.45532426 C15.6663955,4.71536584 16.8268692,6.91064852 16.8268692,6.91064852 L18.5675798,6.91064852",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.80236868902408 12.66952228922094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1.16047374,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.76521111585319 12.66952228922094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1.16047374,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.740710606707097 15.5489591731348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C1.29160727,1.2819253 2.56580743,1.72766213 4.06165808,1.72766213 C5.55750873,1.72766213 6.49169009,0.575887377 8.12331616,0.575887377",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.864026771341067 16.12484654991757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12331616,0 C6.83170889,1.2819253 4.97727186,1.15177475 3.48142121,1.15177475 C1.98557057,1.15177475 1.63162608,0 0,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.283789902438638 19.5801708106142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1.16047374,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.300654380342174 34.66076115485566)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 18.544501312335854)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 27.1100427,0 27.1100427,12.8026115 0,12.8026115 0,0",
    stroke: "none",
    fill: "#25D086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.1639957,0 C17.6159188,1.67657349 15.607906,2.66284777 13.4391026,2.66284777 C11.271234,2.66284777 9.26322115,1.67657349 7.71514423,0 L4.70779915,1.50121522 C1.88928953,2.4745 0,5.11229659 0,8.07390289 L0,17.1103543 L27.1100427,17.11221 L27.1100427,8.30771391 C27.1100427,5.34517979 25.2207532,2.70831102 22.4022436,1.73502625 L19.1639957,0 Z",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.60906784188046 6.030839895013116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.892094,0 15.892094,12.5255906 0,12.5255906 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.93482906,0 L0.93482906,1.39173228 C0.93482906,1.59306955 0.951655983,1.84543701 0.93482906,1.84543701 C0.289797009,1.84543701 0,2.89387533 0,4.17519685 C0,5.45651837 0.523504274,6.49475066 1.16853632,6.49475066 C1.28912927,6.49475066 1.40224359,6.44835958 1.51161859,6.38155643 C2.3707265,9.81727953 5.00040064,12.5255906 7.82919338,12.5255906 C10.6579861,12.5255906 13.5213675,10.2811903 14.3804754,6.84546719 C14.4898504,6.91227034 14.6029647,6.95866142 14.7235577,6.95866142 C15.3685897,6.95866142 15.892094,5.92042913 15.892094,4.63910761 C15.892094,3.35778609 15.602297,2.31955381 14.957265,2.31955381 C14.940438,2.31955381 14.9740919,2.31769816 14.957265,2.31955381 C14.9778312,2.12378346 14.957265,1.59306955 14.957265,1.39173228 L14.957265,0",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.28321314102504 10.20603674540683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0.93482906,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.89218749999964 10.20603674540683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0.93482906,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.543896901708648 1.855643044619399)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 14.0224359,0 14.0224359,5.56692913 0,5.56692913 0,0",
    stroke: "none",
    fill: "#FFD67E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.39173228 L0,4.17519685 C0,4.17519685 2.44644765,5.56692913 7.01121795,5.56692913 C11.5759882,5.56692913 14.0224359,4.17519685 14.0224359,4.17519685 L14.0224359,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.7394097222222626 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.6314103,0 19.6314103,3.71128609 0,3.71128609 0,0",
    stroke: "none",
    fill: "#FFD67E"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "9.3482906,0 0,2.78346457 10.2831197,3.71128609 19.6314103,0.927821522 9.3482906,0 9.3482906,0 9.3482906,0",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.43599091880424 0.9278215223097277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.93482906,0 L0.93482906,4.63910761 L0,6.49475066 L0.93482906,9.27821522 L1.86965812,6.49475066 L0.93482906,4.63910761",
    stroke: "#16243C",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.0 169.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 80,0 80,16 0,16 0,0",
    stroke: "none",
    fill: "#F1F2F4"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.24658891d0186169b110f5d75679535d.svg";
export { ForwardRef as ReactComponent };